import { render, staticRenderFns } from "./IconAngle.vue?vue&type=template&id=a951b494"
import script from "./IconAngle.vue?vue&type=script&lang=js"
export * from "./IconAngle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports